import { render, staticRenderFns } from "./EditMarket.vue?vue&type=template&id=21f565c9&scoped=true"
import script from "./EditMarket.vue?vue&type=script&lang=js"
export * from "./EditMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f565c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f565c9')) {
      api.createRecord('21f565c9', component.options)
    } else {
      api.reload('21f565c9', component.options)
    }
    module.hot.accept("./EditMarket.vue?vue&type=template&id=21f565c9&scoped=true", function () {
      api.rerender('21f565c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/EditMarket.vue"
export default component.exports